/* unplugin-vue-components disabled */import { render } from "./Maxterm.vue?vue&type=template&id=5c87fe7a"
import script from "./Maxterm.vue?vue&type=script&lang=js"
export * from "./Maxterm.vue?vue&type=script&lang=js"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__